import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { RankListItemMessage, RankListResponseWrapper } from "src/app/api/models";

export const branchChampionsEntityKey = 'branchChampions';

export interface BranchChampionsEntity extends RankListResponseWrapper { }

export interface BranchChampionsState extends EntityState<BranchChampionsEntity> { }

export const adapter: EntityAdapter<BranchChampionsEntity> = createEntityAdapter<BranchChampionsEntity>();

const initialBranchChampionsState: BranchChampionsState = adapter.getInitialState(
    {} as BranchChampionsState,
);

export function getInitialBranchChampionsState(): BranchChampionsState {
    return initialBranchChampionsState;
}